<div *ngIf="faq">
    <nb-card>
        <nb-card-header>
            {{faq.domanda? faq.domanda.it : 'Domanda non disponibile'}}</nb-card-header>
        <nb-card-body>
            <div *ngIf="faq.immagine">
                <img [src]="BASE_PATH + '/immagini/informazioni/' + faq.id + '.jpg'">
            </div>
            <p [innerHTML]="faq.risposta? faq.risposta.it : 'Risposta non disponibile'">
            </p>
            <p class="categorie">{{faq.categoria? categorie.get(faq.categoria).title : 'Categoria non disponibile'}}<br>
                <i class="ion-arrow-right-a"></i> {{faq.sottocategoria? sottocategorie.get(faq.sottocategoria).title : 'Sottocategoria non disponibile'}}</p>
            <p>
                <a
                    *ngIf="faq.link"
                    href="{{faq.link? faq.link : '#'}}"
                >
                    <i class="ion-link"></i> {{faq.link_text? faq.link_text : 'Link' }} </a>
            </p>
        </nb-card-body>
    </nb-card>
</div>
